import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryOrderStatusList extends BaseModelAPI {

	static entity = 'deliveryorderstatuslist'
	static entityName = 'deliveryorderstatus';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
